import { ReducerUtility } from '@inter-ikea-kompis/utilities';
import ZipInCardStateEnum from '../../enums/ZipInCardStateEnum.js';
import ZipInActionTypeEnum from './ZipInActionTypeEnum.js';
import ZipInDefaultState from './ZipInDefaultState.js';
import ZipInStepEnum from './ZipInStepEnum.js';
function zipInReducer(state, action) {
    switch (action.type) {
        case ZipInActionTypeEnum.submitZipCode:
            return {
                ...state,
                step: ZipInStepEnum.validation,
                zipInCardState: ZipInCardStateEnum.loading
            };
        case ZipInActionTypeEnum.zipCodeValid:
            return {
                ...state,
                step: ZipInStepEnum.services,
                zipCode: action.zipCode
            };
        case ZipInActionTypeEnum.zipCodeInvalid:
            return {
                ...state,
                step: ZipInStepEnum.error,
                zipInCardState: ZipInCardStateEnum.invalidInput
            };
        case ZipInActionTypeEnum.zipCodeError:
            return {
                ...state,
                step: ZipInStepEnum.error,
                zipInCardState: ZipInCardStateEnum.noZipInfo,
                zipAvailabilities: []
            };
        case ZipInActionTypeEnum.zipCodeEmpty:
            return {
                ...state,
                step: ZipInStepEnum.error,
                zipInCardState: ZipInCardStateEnum.emptyInput
            };
        case ZipInActionTypeEnum.forgetZipCode:
            return {
                ...state,
                zipCode: '',
                step: ZipInStepEnum.default,
                zipInCardState: ZipInCardStateEnum.default,
                assemblyServicesData: null,
                zipAvailabilities: null
            };
        case ZipInActionTypeEnum.servicesDone:
            return {
                ...state,
                step: ZipInStepEnum.submitted,
                zipInCardState: ZipInCardStateEnum.submitted,
                assemblyServicesData: action.assemblyServicesData,
                zipAvailabilities: action.zipAvailabilities
            };
        case ZipInActionTypeEnum.resetErrors:
            // If zip code is set we want to return to the submitted state. Otherwise
            // we can assume we can go back to the original, default state.
            if (state.zipCode) {
                return {
                    ...state,
                    step: ZipInStepEnum.submitted,
                    zipInCardState: ZipInCardStateEnum.submitted
                };
            }
            return {
                ...ZipInDefaultState
            };
    }
}
export default ReducerUtility.exposeReducer(zipInReducer);
//# sourceMappingURL=zipInReducer.js.map